
import fs from 'fs';
import Path from 'path';
import { createVueFile } from './check-type.js';
export const initI18nConfig = () => {

    const rootPath = Path.resolve(process.cwd(), 'i18n')
    // chack if i18n.config is found
    fs.stat(rootPath, (err, stats) => {
        if (err) {
            console.log('create config for i18n');
            fs.mkdirSync(rootPath, { recursive: true });
            const indexPath = Path.resolve(rootPath, "i18n.config.ts")
            createVueFile(indexPath, "i18n_conf", `i18n.config`);
            // create dir for glopal translate lang
            fs.mkdirSync(`${rootPath}/global`, { recursive: true });
            createVueFile(`${rootPath}/global/en.ts`, "i18n", `en`);
            createVueFile(`${rootPath}/global/ar.ts`, "i18n", `ar`);

        }
    });
}
export const integrateI18nToNuxtConfig = () => {
    console.log("integrateI18nToNuxtConfig");
    // /////////////////////////////////////////////////////////////////
    //////chack i18n inside nuxt.config.ts /////////////////////////////
    // /////////////////////////////////////////////////////////////////
    // Detect the correct Nuxt config file (JS or TS)
    const configFiles = ["nuxt.config.js", "nuxt.config.ts"];
    const rootDir = process.cwd(); // Get the root directory of the project
    const configPath = configFiles
        .map((file) => Path.join(rootDir, file))
        .find((filePath) => fs.existsSync(filePath));

    if (!configPath) {
        console.error("❌ No nuxt.config.js or nuxt.config.ts found!");
        process.exit(1);
    }

    // Read the existing config file
    let configContent = fs.readFileSync(configPath, "utf-8");

    // Check if the i18n object exists
    const i18nRegex = /i18n\s*:\s*\{[^}]*\}/;
    const vueI18nLine = 'vueI18n: "./i18n/i18n.config.ts",';

    if (i18nRegex.test(configContent)) {
        // i18n object exists, check if vueI18n is inside
        if (!configContent.includes(vueI18nLine)) {
            configContent = configContent.replace(i18nRegex, (match) => {
                return match.replace(/\}$/, `  ${vueI18nLine}\n}`);
            });
            console.log("Added vueI18n inside existing i18n object.");
        } else {
            console.log("⚡ vueI18n is already set.");
        }
    } else {
        // i18n object does not exist, add it
        if (/export default defineNuxtConfig\(\{/.test(configContent)) {
            configContent = configContent.replace(
                /export default defineNuxtConfig\(\{/,
                `export default defineNuxtConfig({\n  i18n: {\n    ${vueI18nLine}\n  },`
            );
            console.log("Added i18n object with vueI18n.");
        } else {
            console.error("❌ Could not find 'export default defineNuxtConfig({ ... })' in Nuxt config.");
            process.exit(1);
        }
    }

    // Save the modified config
    fs.writeFileSync(configPath, configContent, "utf-8");
    console.log("Nuxt config updated successfully!");
}

